/* ==========================================================================
   Descena — ds-cro.js (CRO-Ausbau 11.10.2026)
   Kleine, unabhängige Bausteine ohne Framework:
   1. Angebotswahl (Tränke einzeln / Spar-Set) setzt die Varianten-ID im
      echten Dawn-Produktformular. Ein Formular, eine Wahrheit.
   2. Lieferdatum „voraussichtlich Mi., 14.10. bis Do., 15.10." aus der
      geltenden Zusage „Lieferung in 2 bis 3 Werktagen" (Mo bis Fr, bundesweite
      Feiertage, Bestellschluss 13 Uhr Berliner Zeit). Ohne JS bleibt der
      Fallback-Text stehen.
   3. Ratgeber-Kaufleiste: erscheint nach 30 % Lesestrecke.
   4. Warenkorb: Ein-Klick-Wechsel von der Einzeltränke zum Spar-Set.
   ========================================================================== */
(function () {
  'use strict';

  function fmtEuro(cents) {
    var n = (parseInt(cents, 10) || 0) / 100;
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  /* ---------- 1. Angebotswahl ---------- */
  function initOffer() {
    var boxes = document.querySelectorAll('[data-ds-offer]');
    Array.prototype.forEach.call(boxes, function (box) {
      var form = document.getElementById(box.getAttribute('data-form'));
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;
      var sid = box.getAttribute('data-section');
      var priceEl = document.querySelector('#price-' + sid + ' .price__regular .price-item--regular');
      var satcPrice = document.querySelector('[data-ds-satc-price]');
      var satcTitle = document.querySelector('.ds-satc__title');
      var satcTitleDefault = satcTitle ? satcTitle.textContent : '';

      function apply(input) {
        if (!input) return;
        idInput.value = input.value;
        idInput.disabled = false;
        var price = input.getAttribute('data-price');
        if (priceEl) priceEl.textContent = fmtEuro(price);
        if (satcPrice && box.hasAttribute('data-main')) satcPrice.textContent = fmtEuro(price);
        if (satcTitle && box.hasAttribute('data-main')) {
          satcTitle.textContent = input.getAttribute('data-short') || satcTitleDefault;
        }
        Array.prototype.forEach.call(box.querySelectorAll('.ds-offer__opt'), function (opt) {
          opt.classList.toggle('is-selected', opt.contains(input));
        });
      }

      box.addEventListener('change', function (e) {
        if (e.target && e.target.matches('input[type="radio"]')) apply(e.target);
      });
      /* Zurück-Navigation (bfcache) stellt den Radio-Zustand wieder her: angleichen. */
      apply(box.querySelector('input[type="radio"]:checked'));
    });
  }

  /* ---------- 2. Lieferdatum ---------- */
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
      h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(y, month - 1, day));
  }
  function key(d) { return d.toISOString().slice(0, 10); }
  function holidays(y) {
    var o = easter(y), add = function (n) { return key(new Date(o.getTime() + n * 864e5)); };
    return [y + '-01-01', add(-2), add(1), y + '-05-01', add(39), add(50), y + '-10-03', y + '-12-25', y + '-12-26'];
  }
  function isWorkday(d) {
    var wd = d.getUTCDay();
    if (wd === 0 || wd === 6) return false;
    return holidays(d.getUTCFullYear()).indexOf(key(d)) === -1;
  }
  function addWorkdays(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) { r = new Date(r.getTime() + 864e5); if (isWorkday(r)) n--; }
    return r;
  }
  function berlinNow() {
    try {
      var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false })
        .formatToParts(new Date()).reduce(function (acc, x) { acc[x.type] = x.value; return acc; }, {});
      return { day: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), hour: parseInt(p.hour, 10) % 24 };
    } catch (e) {
      var n = new Date();
      return { day: new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())), hour: n.getHours() };
    }
  }
  var WT = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
  function fmtDay(d) {
    return WT[d.getUTCDay()] + ' ' + ('0' + d.getUTCDate()).slice(-2) + '.' + ('0' + (d.getUTCMonth() + 1)).slice(-2) + '.';
  }
  function initEta() {
    var els = document.querySelectorAll('[data-ds-eta]:not(.is-dated)');
    if (!els.length) return;
    var now = berlinNow(), start = now.day;
    /* Bestellschluss 13 Uhr: danach, am Wochenende oder Feiertag zählt der nächste Werktag als Tag 0. */
    if (!isWorkday(start) || now.hour >= 13) start = addWorkdays(start, 1);
    var from = addWorkdays(start, 2), to = addWorkdays(start, 3);
    Array.prototype.forEach.call(els, function (el) {
      var out = el.querySelector('[data-ds-eta-text]');
      if (!out) return;
      out.innerHTML = (el.getAttribute('data-prefix') || 'Lieferung voraussichtlich') +
        ' <strong class="ds-eta__date">' + fmtDay(from) + ' bis ' + fmtDay(to) + '</strong>';
      el.classList.add('is-dated');
    });
  }

  /* ---------- 3. Ratgeber-Kaufleiste ---------- */
  function initArticleBar() {
    var bar = document.querySelector('.ds-abar');
    if (!bar) return;
    var article = document.querySelector('.article-template') || document.querySelector('article');
    var closed = false;
    try { closed = sessionStorage.getItem('ds-abar-zu') === '1'; } catch (e) {}
    if (closed) return;
    var close = bar.querySelector('.ds-abar__close');
    if (close) close.addEventListener('click', function () {
      bar.classList.remove('is-active');
      document.documentElement.classList.remove('ds-abar-on');
      closed = true;
      try { sessionStorage.setItem('ds-abar-zu', '1'); } catch (e) {}
    });
    var ticking = false;
    function check() {
      ticking = false;
      if (closed) return;
      var total = (article ? article.offsetTop + article.offsetHeight : document.documentElement.scrollHeight) - window.innerHeight;
      var y = window.scrollY || window.pageYOffset;
      var nearEnd = document.documentElement.scrollHeight - (y + window.innerHeight) < 900;
      var on = total > 0 && y / total > 0.3 && !nearEnd;
      bar.classList.toggle('is-active', on);
      document.documentElement.classList.toggle('ds-abar-on', on);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(check); }
    }, { passive: true });
    check();
  }

  /* ---------- 4. Warenkorb: zum Spar-Set wechseln ---------- */
  function initCartSwap() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-ds-swap-btn]');
      if (!btn) return;
      var box = btn.closest('[data-ds-swap]');
      if (!box || btn.getAttribute('aria-busy') === 'true') return;
      e.preventDefault();
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      var updates = {};
      updates[box.getAttribute('data-key')] = 0;
      updates[box.getAttribute('data-set')] = parseInt(box.getAttribute('data-qty'), 10) || 1;
      var drawer = document.querySelector('cart-drawer');
      var body = { updates: updates };
      if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
      fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (state) {
        if (drawer && state && state.sections && typeof drawer.renderContents === 'function') {
          state.id = box.getAttribute('data-set');
          drawer.renderContents(state);
        } else {
          window.location.reload();
        }
      }).catch(function () { window.location.reload(); });
    });
  }

  /* Der Warenkorb-Drawer wird nach jedem Hinzufügen neu gerendert: Lieferdatum dort nachziehen.
     Bereits datierte Elemente tragen .is-dated, dadurch keine Endlosschleife. */
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !('MutationObserver' in window)) return;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(initEta, 30);
    }).observe(drawer, { childList: true, subtree: true });
  }

  /* ---------- 5. Footer-Akkordeon mobil ---------- */
  function initFooterFold() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
    /* Die Liste mit „Vertrag widerrufen“ bleibt offen: gesetzliche Widerrufsfunktion muss ständig sichtbar sein (§ 356a BGB). */
    Array.prototype.forEach.call(document.querySelectorAll('details.ds-fold[open]'), function (d) {
      if (d.querySelector('a[href*="/apps/widerruf"]')) return;
      d.removeAttribute('open');
    });
  }

  function init() { initOffer(); initEta(); initArticleBar(); initCartSwap(); watchDrawer(); initFooterFold(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
